//----------------------------------------------------------------------
//	NAVIGATION CHAPTERS
//	Custom Package
//----------------------------------------------------------------------

var NavChapters = {
	selectorContainer: '[data-chapter]',
	selector: '[data-chapter-trigger]',
	linkNav: '[data-nav-link]',
	classCurrent: 'current',
	lineBar: '.nav-chapters__line',
	lineBarIndicator: $('.nav-chapters__line-indicator'),
	containerPercentage: '[data-percentage]',
	scrollPercentage: '[data-percentage-number]',
	windowSize: 0,
	winScroll: 0,
	listNav: '.list-nav',
	section: '[data-section]',
	heading: '[data-heading]',
	sectionHeading: '[data-section-heading]',
	verticalClass: 'nav-chapters--vertical',
	selectorPublication: '[data-publication]',
	contentPublication: false,
	isSticky: false,
	isEndPoint: false,
	stopSticky: false,
	isHorizontal: false,
	isOpen: false,
	navListItem: '.list-nav__item',
	classActive: 'active',
	backLinkNav: '[data-back]',
	headerHeight: 0,
	navHeightInitial: 0,
	navNoStickyHeight: 0,
	contentHeight: 0,
	viewPortHeight: 0,
	navChapersOffset: 0,
	contentOffset: 0,
	endStickyPosition: 0,
	topOffsetDesk: 0,
	winScrollRound: 0,
	navBreakPoint: 1100,

	init: function () {
		// return if the container not present
		if (!$(this.selectorContainer).length) return;
		if ($(this.selectorPublication).length) {
			this.contentPublication = true;
		} else {
			this.isHorizontal = true;
			this.addHorizontalClass();
		}
		this.bindChangeEvent();
		this.getWindowSize();
		this.getElSize();
		this.getHeading();
		this.addLineBar();
		this.showScrollingPercentage();
		this.bindScrollEvent();
		this.setStickyPosition();
		if (this.windowSize < 1024) {
			this.setAriaAttrs();
			this.bindClickButton();
		} else {
			NavChapters.bindExpanderLink();
		}
	},

	getHeading: function () {

		// find all headings in the page
		var heading2 = $('.page-section').find('h2').not('.exclude-navigation');
		heading2.attr('data-heading', '');

		// for each heading find its section container
		$(heading2).each(function (i) {

			var $thisHeading = $(this),
				textH2 = $(this).text();

			var $section = $(this).parent('.page-section');

			if (NavChapters.isHorizontal) {
				$section = $(this).parents('.page-section');
				$section.attr('data-section', '');
			} else {
				if ($thisHeading.hasClass('box__h2')) {
					$section = $(this).parents().eq(1);
				}
			}

			NavChapters.createNav(textH2, i, $section, $thisHeading);
		});

		NavChapters.bindClickLink();

		$(NavChapters.heading).each(function () {
			var $this = $(this);
			if (NavChapters.contentPublication) {
				$this.nextUntil(NavChapters.heading).addBack().wrapAll('<div class="section-heading" data-section-heading></div>');
			}

		});

	},

	createNav: function (textH2, i, $section, $thisHeading) {

		// do not create the navigation if the CMS content editor is open
		var bodyEdit = '.pagemode-edit';

		if ($(bodyEdit).length) return;

		var elementH3 = $thisHeading.nextUntil('h2', 'h3:not(.exclude-navigation)');

		// create the markup for each element found
		$(NavChapters.listNav).append("<li class='list-nav__item'><a class='list-nav__link' href='#chapter-" + i + "' data-nav-link>" + textH2 + "</a></li>");

		// add IDs to headings
		$thisHeading.attr('id', 'chapter-' + i);
		var $thisH2Id = $thisHeading.attr('id');
		var h2Link = '[href="#' + $thisH2Id + '"]';

		// add back link to section title
		if (!NavChapters.contentPublication) {
			var backLinkHTML = '<div class="container"><div class="col12"><p class="txtr"><a class="scroll-to-top" href="#" data-back>Back to <span aria-hidden="true">top</span><span class="visually-hidden">heading links</span></a></p></div></div>';
			$section.append(backLinkHTML);
		}

		// add secondary nav to publications
		if (NavChapters.contentPublication) {

			$(h2Link).each(function () {

				var $thisMatched = $(this);

				// if link has H3 child add secondary nav
				if (elementH3.length) {

					$thisMatched.addClass('has-child');
					$thisMatched.after($('<ul class="list-nav-secondary"></ul>'));

				}

				// for each H3 add id and markup to the secondary nav of the link matched
				elementH3.each(function (i) {

					var $thisH3 = $(this),
						thisH3Text = $thisH3.text(),
						thisH3Id = $thisH2Id + '-' + i;

					// set ids to headings
					$thisH3.attr('id', thisH3Id);
					$thisH3.attr('data-heading', '');
					$thisMatched.next($('.list-nav-secondary')).append("<li class='list-nav-secondary__item'><a class='list-nav-secondary__link' href='#" + thisH3Id + "' data-nav-link>" + thisH3Text + "</a></li>");

				});
			});
		}

		// update nav height after being created
		NavChapters.navHeightInitial = $(NavChapters.selectorContainer).height();

		NavChapters.getInViewSection();

	},

	bindClickLink: function () {

		$(NavChapters.linkNav).on('click', function (e) {

			var thisLink = $(this);
			NavChapters.checkOffsetSection(thisLink);
			NavChapters.removeClassActive();
			NavChapters.addClassActive(thisLink);


			if (NavChapters.windowSize < 1024) {
				$(NavChapters.selectorContainer).removeClass('active');
				NavChapters.resetAriaAttrs();
			}

			// set focus for keyboard users
			setTimeout(function () {
				NavChapters.setFocus(thisLink);
			}, 100);


			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

		});

		if ($(NavChapters.backLinkNav)) {
			$(NavChapters.backLinkNav).on('click', function (e) {
				// prevent default click
				e.preventDefault();
				$("html, body").animate({ scrollTop: 0 }, 1000);
				// set focus back to nav links
				setTimeout(function () {
					$(NavChapters.selectorContainer).attr('tabindex', '-1').trigger('focus');
				}, 100);
			});
		};
	},

	bindExpanderLink: function () {

		if (NavChapters.contentPublication) {

			var $this = $(this),
				$thisParent = $this.parents('#output');

			$('.accordion-button').on('click', function (e) {

				if (NavChapters.windowSize >= 1024) {

					// if you click on an accordion which is inside an #output container
					if ($thisParent.length) {
						setTimeout(function () {
							NavChapters.removeEndPointClass();
							NavChapters.addStickyClass();
							$(NavChapters.selectorContainer).css('top', NavChapters.headerHeight);
						}, 100);
					}

					setTimeout(function () {
						NavChapters.getElSize();
					}, 270);

					setTimeout(function () {
						NavChapters.setStickyPosition();
					}, 280);

					// prevent default click behavior
					e.preventDefault();
					// stopPropagation to prevent the button click from bubbling up the DOM
					e.stopPropagation();
				} else {

					NavChapters.resetPosition();
				}

			});
		}
	},

	bindChangeEvent: function () {

		// reset the functions and recalculate the values
		$(window).on('orientationchange resize load', function () {

			// Throttle the resize event to fix mobile bug
			clearTimeout(this.id);
			this.id = setTimeout(function () {
				if (NavChapters.windowSize !== $(window).width()) {

					NavChapters.getWindowSize();

					if (NavChapters.contentPublication) {
						NavChapters.contentHeight = $('[data-publication]').height();
					}

					if ($(NavChapters.selectorContainer).hasClass('sticky')) {
						NavChapters.removeStickyClass();
					}

					if ($(NavChapters.selectorContainer).hasClass('endpoint')) {
						NavChapters.removeEndPointClass();
					}

					NavChapters.resetAriaAttrs();

					if (NavChapters.windowSize < 1024) {
						NavChapters.resetPosition();
						NavChapters.unbindClickButton();
						NavChapters.bindClickButton();
						NavChapters.resetHeight();
					} else {
						NavChapters.bindExpanderLink();
					}

					NavChapters.getElSize();
					NavChapters.setStickyPosition();

				}
			}, 10);
		});

	},

	bindClickButton: function () {
		// on clink event get the parent container and add active class
		$(NavChapters.selector).on('click', function (e) {

			var $thisSelector = $(this);

			// animate the height of the content and set the aria attributes
			NavChapters.animateNavChapt($thisSelector);

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

		});

	},

	unbindClickButton: function () {

		$(NavChapters.selector).off("click");
	},

	checkOffsetSection: function (thisLink) {

		// get the section offset position and the height of each top elements
		var offSetEl = $(thisLink.attr('href')).offset().top,
			offsetRound = Math.round(offSetEl),
			navButtonHeight = $(NavChapters.selector).outerHeight(),
			lineHeight = $(NavChapters.lineBarIndicator).height(),
			navChapBar = navButtonHeight + lineHeight,
			combinedHeight = NavChapters.navHeightInitial + NavChapters.headerHeight,

			// calculate the end scroll position for horizontal nav layout
			endScroll = offsetRound - navChapBar - 15,
			endScrollNoSticky = offsetRound - (navChapBar + NavChapters.navNoStickyHeight + 15),
			endScrollNoStickyDesk = offsetRound - (combinedHeight + NavChapters.navHeightInitial + 35),
			endScrollDesk = offsetRound - combinedHeight - 25;

		if (NavChapters.contentPublication && NavChapters.windowSize >= 1024) {

			NavChapters.jumpToHeading(offsetRound);

		} else {
			// horizontal nav layout
			NavChapters.jumpToSection(endScroll, endScrollDesk, endScrollNoSticky, endScrollNoStickyDesk, navChapBar);
		}

	},

	jumpToHeading: function (offsetRound) {

		var contentHeading = offsetRound - (NavChapters.headerHeight + 15);

		$('html, body').animate({ scrollTop: contentHeading }, 500);

	},

	jumpToSection: function (endScroll, endScrollDesk, endScrollNoSticky, endScrollNoStickyDesk, navChapBar) {

		if (NavChapters.windowSize >= 1024) {

			if ($(NavChapters.selectorContainer).hasClass('sticky')) {

				if (NavChapters.windowSize >= NavChapters.navBreakPoint) {
					$('html, body').animate({ scrollTop: endScrollDesk }, 500);
				} else {
					$('html, body').animate({ scrollTop: endScrollDesk + navChapBar }, 500);
				}


			} else {
				if (NavChapters.windowSize >= NavChapters.navBreakPoint) {
					$('html, body').animate({ scrollTop: endScrollNoStickyDesk }, 500);
				} else {
					$('html, body').animate({ scrollTop: endScrollNoStickyDesk + navChapBar }, 500);
				}

			}

		} else {
			if ($(NavChapters.selectorContainer).hasClass('sticky')) {
				$('html, body').animate({ scrollTop: endScroll - 5 }, 500);
			} else {
				$('html, body').animate({ scrollTop: endScrollNoSticky - 5 }, 500);
			}
		}
	},

	getInViewSection: function () {

		var combinedNavHeight = NavChapters.navHeightInitial + NavChapters.headerHeight;

		$(window).on('scroll', function () {

			// get current section and headings through inview filter
			var $currentHeading = $(inView(NavChapters.sectionHeading, 'top', -100)),
				$currentSection;

			if (NavChapters.contentPublication) {
				$currentSection = $(inView(NavChapters.section, 'top', -100));
			} else {
				// Horizontal bar 
				// current section is H2 position minus top navigation + chatper navigation 
				$currentSection = $(inView(NavChapters.section, 'top', - combinedNavHeight));
			}

			// if filtered selection returns an element
			if ($currentSection) {
				if (NavChapters.contentPublication) {

					// get id and matching nav element
					var currentSectionId = $currentSection.find('h2').attr('id'),
						$navItem = $(NavChapters.linkNav + '[href="#' + currentSectionId + '"]'),
						$navList = $navItem.parent('.list-nav__item');

					// remove class from other nav items and add current class to current section
					$(NavChapters.navListItem).not(NavChapters.classCurrent).removeClass(NavChapters.classCurrent);
					$navList.addClass(NavChapters.classCurrent);
				} else {

					// get id and matching nav element
					var currentH2Id = $currentSection.find('h2').attr('id'),
						$navItemH2 = $(NavChapters.linkNav + '[href="#' + currentH2Id + '"]');


					// remove class from other nav items and add current class to current section
					NavChapters.removeClassActive();

					NavChapters.addClassActive($navItemH2);

				}
			}

			if (NavChapters.contentPublication && $currentHeading) {
				// get id and matching nav element
				var currentHeading = $currentHeading.find(NavChapters.heading),
					currentHeadingId = $(currentHeading).attr('id'),
					$navItemMatched = $(NavChapters.linkNav + '[href="#' + currentHeadingId + '"]');

				NavChapters.removeClassActive();
				NavChapters.addClassActive($navItemMatched);
			}

		});

	},

	addClassActive: function (thisLink) {
		thisLink.addClass(NavChapters.classActive);
	},

	removeClassActive: function () {
		$(NavChapters.linkNav).removeClass(NavChapters.classActive);
		//NavChapters.unBindTouchEvent();
	},

	addLineBar: function () {

		// get the offset position of the navbar
		$(window).on('scroll', function () {

			var winScroll = document.body.scrollTop || document.documentElement.scrollTop,
				heightDoc = document.documentElement.scrollHeight - document.documentElement.clientHeight,
				scrolled = winScroll / heightDoc * 100,
				scrolledRound = Math.round(scrolled);


			// add the scrolled position to the line bar
			$(NavChapters.lineBarIndicator).css('width', +scrolledRound + "%");

			$(NavChapters.scrollPercentage).text(scrolledRound + '%');

			if ($(NavChapters.containerPercentage).hasClass('hide')) {
				NavChapters.removeHideClass();
			}


		});

	},

	showScrollingPercentage: function () {

		$(window).on('scroll', function () {

			clearTimeout($.data(this, 'scrollTimer'));
			$.data(this, 'scrollTimer', setTimeout(function () {
				// hide percentage
				NavChapters.addHideClass();

			}, 1000));
		});
	},

	addHideClass: function () {

		$(NavChapters.containerPercentage).addClass('hide');
	},

	removeHideClass: function () {
		$(NavChapters.containerPercentage).removeClass('hide');
	},

	getElSize: function () {

		NavChapters.headerHeight = $('.global-header').height();
		//NavChapters.navHeightInitial = $(NavChapters.selectorContainer).height(),
		NavChapters.viewPortHeight = $(window).height(),
			NavChapters.navChapersOffset = Math.round($('.nav-chapters').offset().top);

		if (NavChapters.contentPublication) {
			NavChapters.contentOffset = Math.round($('.container-publication').offset().top),
				NavChapters.contentHeight = $('[data-publication]').height(),
				NavChapters.endStickyPosition = NavChapters.contentOffset + NavChapters.contentHeight - (NavChapters.navHeightInitial + NavChapters.headerHeight);
		}

	},

	getWindowSize: function () {
		// get window width and update the global value
		NavChapters.windowSize = window.innerWidth;
		NavChapters.viewPortHeight = $(window).height();
	},

	setStickyPosition: function () {

		NavChapters.topOffsetDesk = NavChapters.contentOffset - NavChapters.headerHeight;
		var combinedNavHead = NavChapters.navChapersOffset - NavChapters.headerHeight;

		// if the layout is laptop and is publication
		if (NavChapters.contentPublication) {

			var combinedNavHeight = NavChapters.navHeightInitial + NavChapters.headerHeight;

			if (NavChapters.windowSize >= 1024) {

				// set the top posion of the nav bar to 0 if is a publication
				$(NavChapters.selectorContainer).css('top', '0');

				//add and remove sticky class if the scrolling position is greater than offset nav position
				if (NavChapters.winScrollRound >= NavChapters.topOffsetDesk) {

					if (NavChapters.isEndPoint === false) {

						NavChapters.addStickyClass();
					}

				} else {

					NavChapters.removeStickyClass();

				}


				// if the viewport height is greater than the initial navigation height 
				if (NavChapters.viewPortHeight >= combinedNavHeight) {

					$(NavChapters.selectorContainer).css('height', 'auto');

					// when the scroll is greater than initial height end position 
					if (NavChapters.winScrollRound >= NavChapters.endStickyPosition) {

						NavChapters.removeStickyClass();
						NavChapters.addEndPointClass();

					} else {

						NavChapters.removeEndPointClass();

					}

				} else {

					// when the view port reaches the end position initial height
					if (NavChapters.winScrollRound >= NavChapters.endStickyPosition) {

						NavChapters.removeStickyClass();
						$(NavChapters.selectorContainer).css('height', 'auto');
						NavChapters.addEndPointClass();

					} else {

						NavChapters.removeEndPointClass();

						// if tablet layout
						$(NavChapters.selectorContainer).css('height', 'calc(100% - 40px)');

						// if laptop layout
						if (NavChapters.windowSize >= NavChapters.navBreakPoint) {
							$(NavChapters.selectorContainer).css('height', 'calc(100% - 96px)');
						}
					}
				}


				// set the top posion of the nav bar
				if (NavChapters.isSticky) {

					if (NavChapters.isEndPoint === false) {

						if (NavChapters.windowSize >= 1100) {

							$(NavChapters.selectorContainer).css('top', NavChapters.headerHeight);
						} else {

							$(NavChapters.selectorContainer).css('top', '0');

						}

					} else {

						$(NavChapters.selectorContainer).css('top', 'auto');
					}
				} else {

					$(NavChapters.selectorContainer).css('top', '0');
				}

			} else {

				if (NavChapters.winScrollRound >= NavChapters.navChapersOffset) {

					NavChapters.addStickyClass();
				} else {

					NavChapters.removeStickyClass();
				}
			}

		} else {
			// Horizontal bar (knowledgebank)
			// add the sticky class to the navbar when you reach its scroll position.Remove "sticky" when you leave the scroll position
			if (NavChapters.windowSize >= NavChapters.navBreakPoint && NavChapters.winScrollRound >= combinedNavHead || NavChapters.windowSize < NavChapters.navBreakPoint && NavChapters.winScrollRound >= NavChapters.navChapersOffset) {

				NavChapters.addStickyClass();

			} else {
				NavChapters.removeStickyClass();
			}

			// set the top posion of the nav bar
			if (NavChapters.windowSize >= NavChapters.navBreakPoint) {

				$(NavChapters.selectorContainer).css('top', NavChapters.headerHeight);

			} else {
				$(NavChapters.selectorContainer).css('top', '0');
			}


		}

	},

	bindScrollEvent: function () {

		$(window).on('scroll', function () {

			// get scrolling position
			var winScroll = $(window).scrollTop();
			NavChapters.winScrollRound = Math.round(winScroll);

			NavChapters.setStickyPosition();
		});
	},

	resetHeight: function () {

		$(NavChapters.selectorContainer).css('height', 'auto');
	},

	resetPosition: function () {

		// set the top posion of the nav bar
		$(NavChapters.selectorContainer).css('top', '0');
	},

	addEndPointClass: function () {
		NavChapters.isEndPoint = true;
		$(NavChapters.selectorContainer).addClass('endpoint');
	},

	removeEndPointClass: function () {
		NavChapters.isEndPoint = false;
		$(NavChapters.selectorContainer).removeClass('endpoint');
	},

	addStickyClass: function () {
		NavChapters.isSticky = true;
		$(NavChapters.selectorContainer).addClass("sticky");
		if (NavChapters.windowSize <= 1024 && NavChapters.contentPublication) {
			$(NavChapters.lineBar).addClass("sticky");
		}
	},

	removeStickyClass: function () {
		NavChapters.isSticky = false;
		$(NavChapters.selectorContainer).removeClass("sticky");
		if (NavChapters.windowSize <= 1024 && NavChapters.contentPublication) {
			$(NavChapters.lineBar).removeClass("sticky");
		}
	},

	setFocus: function (thisLink) {

		var $currentSection = $(thisLink.attr('href'));
		$currentSection.attr('tabindex', '-1').trigger('focus');
	},

	setAriaAttrs: function () {

		// add aria-controls to button and hidden content
		$(NavChapters.selector).attr('aria-expanded', false);
		$(NavChapters.listNav).attr('aria-hidden', true);
	},

	resetAriaAttrs: function () {

		// set aria to initial values and remove the attr if it's desk layout
		if (NavChapters.windowSize < 1024) {

			$(NavChapters.selector).attr('aria-expanded', false);

			$('#list-chapters').attr('aria-hidden', true);

		} else {
			$(NavChapters.selector).removeAttr('aria-expanded');
			$('#list-chapters').removeAttr('aria-hidden');

		}

	},

	animateNavChapt: function ($thisSelector) {

		var state = $thisSelector.attr('aria-expanded') === 'false' ? true : false,
			contentHidden = $(NavChapters.listNav).attr('aria-hidden') === 'true' ? false : true;

		// set btn state
		$thisSelector.attr('aria-expanded', state);
		$('.list-nav').attr('aria-hidden', contentHidden);

		// set nav height if the nav is not sticky
		if (NavChapters.windowSize < 1024) {
			setTimeout(function () {
				if (!contentHidden) {
					NavChapters.navNoStickyHeight = $(NavChapters.selectorContainer).height();
				}
			}, 100);
		}
	},

	addHorizontalClass: function () {

		$(NavChapters.selectorContainer).addClass('nav-chapters--horizontal');
	}
};

$(document).ready(function () {
	NavChapters.init();
});